import { Currency, getMoneySymbolByCurrency } from '@nemuru-eng/js-api-client';

import { FormSectionWrapper } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/_shared/FormSectionWrapper';
import { NumberOfYearlyPaymentsOptions } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/BorrowerOnboardingDetailsForm/components/DeclaredIncomeForm/constants/NumberOfYearlyPaymentsOptions';
import { useMerchantPos } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/hooks/useMerchantPos';
import { NetIncomeTypeOptions } from '@/components/modules/DeclaredIncome/constants/NetIncomeTypeOptions';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { NumberFormField } from '@/components/shared/components/NewContextForms/NumberFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface DeclaredIncomeFormProps extends FormGridOptions {}

export const DeclaredIncomeForm = ({ fullWidth, fieldVariant, direction }: DeclaredIncomeFormProps) => {
  const { selectedRole, currency } = useMerchantPos();

  const { getTextIdTranslation: t } = useTranslation();

  if (!selectedRole) {
    return null;
  }

  return (
    <FormSectionWrapper
      titleTid="NET_INCOME"
      subtitleTid="NET_INCOME_FORM_INFO"
      subtitleTidDynamicTexts={[t(selectedRole)]}
    >
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth} direction={direction}>
        <NumberFormField
          label={'MONTHLY_NET_INCOME'}
          name={'monthlyNetIncome'}
          valueUnit={getMoneySymbolByCurrency(currency ?? Currency.EUR)}
          fieldVariant={fieldVariant}
        />
        <SelectFormField
          label={'NUMBER_OF_YEARLY_PAYMENTS'}
          name={'numberOfYearlyPayments'}
          selectOptions={NumberOfYearlyPaymentsOptions}
          fieldVariant={fieldVariant}
        />
        <SelectFormField
          label={'INCOME_TYPE'}
          name={'netIncomeType'}
          selectOptions={NetIncomeTypeOptions}
          fieldVariant={fieldVariant}
        />
      </FormGridContainer>
    </FormSectionWrapper>
  );
};
